import React from 'react';

interface SaudiRiyalProps {
  amount?: number | string;
  className?: string;
  variant?: 'regular' | 'bold' | 'new' | 'bold_new';
  showAmount?: boolean;
}

export const SaudiRiyal: React.FC<SaudiRiyalProps> = ({ 
  amount, 
  className = '', 
  variant = 'new',
  showAmount = true 
}) => {
  const getIconClass = () => {
    switch (variant) {
      case 'regular':
        return 'icon-saudi_riyal';
      case 'bold':
        return 'icon-saudi_riyal_bold';
      case 'new':
        return 'icon-saudi_riyal_new';
      case 'bold_new':
        return 'icon-saudi_riyal_bold_new';
      default:
        return 'icon-saudi_riyal_new';
    }
  };

  const formatAmount = (value: number | string) => {
    if (typeof value === 'number') {
      return value.toLocaleString('ar-SA');
    }
    return value;
  };

  return (
    <span className={`inline-flex items-center gap-1 ${className}`}>
      <span className={`${getIconClass()} text-current text-3xl`}></span>
      {showAmount && amount && (
        <span>{formatAmount(amount)}</span>
      )}
    </span>
  );
};

export default SaudiRiyal;
